import { Component, OnInit  } from '@angular/core';
import { AuthService } from '../../service/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'src/app/service/toaster.service';
import { CommonService } from 'src/app/service/common.service';
import { ProfileService } from 'src/app/profile/profile-service.service';
import { TranslationService } from 'src/app/service/translation.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit{
  phone: string = '';
  showOTPVerification: boolean = false;
  showLogin: boolean = true;
    termsUrl: string = `${environment.domain}/terms-conditions`;
  privacyUrl: string = `${environment.domain}/privacy-policy`;
  
  constructor(
    public authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToasterService,
    private commonService: CommonService,
    private profileService: ProfileService,
    public translationService: TranslationService
  ) {}
  
  ngOnInit(): void {
    this.showOTPVerification = false;    
  }

  getUserPhone(phone:string){
    this.phone = phone;
  }
  
  userLoggedIn(event: any){
    if(event){
      this.toastr.success(this.translationService.instant('auth.loginSuccess','User Logged In Successfully'), this.translationService.instant('success.title','Success'));
      this.commonService.getApplicationConfig().subscribe((res:any) => {
        if(res && res.data){
          localStorage.setItem('appConfig', JSON.stringify(res.data));
        }
      });
      this.profileService.getVendorProfile().subscribe((res:any) => {
        if(res && res.data){
          localStorage.setItem('vendorProfile', JSON.stringify(res.data));
        }
      });
      const returnUrl = this.route.snapshot.queryParams['returnUrl'];
      if (returnUrl) {
        this.router.navigateByUrl(returnUrl);
      } else {
        this.router.navigate(['/dashboard']);
      }
    }
  }
}
